import { LinkBox } from "../components/LinkBox";
import { Header } from "../components/Header";
import styled from 'styled-components'
import { theme } from "../theme";
import { Search, PersonPinRounded, CheckCircle, Photo, AdminPanelSettings, Download } from '@mui/icons-material';
import { Link } from "../components/Link";
import { TextInput } from "../components/TextInput";
import { Text } from "../components/Text";
import { Box } from "../components/Box";
import { Button } from "../components/Button";
import { useState } from "react";
import { uuidGenerator } from "../services/UuidGenerator/UuidGenerator";
import QRCode from "react-qr-code";
import { useNavigate } from "react-router-dom";
import { newPatientFormsLinkGenerator } from "../services/NewPatientFormsLinkGenerator";
import { config } from "../config";

export function NewPatientFormGenerator() {
  const navigate = useNavigate()

  const [chartNumber,setChartNumber] = useState('')

  async function generateLink(viewer: 'patient' | 'dentist') {
    const sessionId = await newPatientFormsLinkGenerator.generate(chartNumber, viewer)

    if (viewer === 'patient') {
      navigate(`/new-patient-form/${sessionId}`)
    }
    
    if (viewer === 'dentist') {
      window.open(`${config.frontEndUrl}/Forms/NewPatientForm/${sessionId}`,'_blank')
    }
  }

  return (
    <>
      <Header />
      <Box 
        alignHorizontal="center" 
        alignVertical="center" 
        direction="vertical"
        paddingTopCode="xl"
      >

        <Box paddingTopCode="xl" />

        <Text size="xxl" weight="strong">
           New Patient Forms
        </Text>

        <Box paddingTopCode="xs" />

        <Text size="md" color="secondary">
          Enter the chart number of a patient to generate a link and QR code.
        </Text>

        <Box paddingTopCode="xl" />

        <TextInput 
          autofocus 
          value={chartNumber} 
          onChange={(newValue) => setChartNumber(newValue)} 
          placeholder="Chart Number" 
          onEnter={() => generateLink('patient')} 
        />

        <Box paddingTopCode="xxxs" />
        
        <Button label="Generate Patient Link" onClick={() => generateLink('patient')} disabled={!chartNumber} />

        <Box paddingTopCode="xxxs" />

        <Button label="View Forms" onClick={() => generateLink('dentist')} disabled={!chartNumber} />

      </Box>
    </>
  )
}